import React from 'react';
import { Alert } from 'antd';

type ConnectConfig = {
  postTo: string;
  sync?: {
    comments?: boolean;
    status?: boolean;
  };
  map?: {
    status?: string;
  };
  notifications?: boolean;
  reconnectMessage?: React.ReactNode;
};

export const config: {
  [key: string]: ConnectConfig;
} = {
  asana: { postTo: 'an Asana project', sync: { comments: true } },
  clickup: { postTo: 'a ClickUp list', sync: { comments: true }, map: {} },
  github: { postTo: 'your GitHub repository', sync: { comments: true } },
  jira: {
    postTo: 'your Jira kanban board',
    sync: { comments: true, status: true }
  },
  microsoftTeams: {
    postTo: 'your Microsoft Teams channel',
    sync: { status: true }
  },
  slack: {
    postTo: 'your Slack workspace',
    notifications: true,
    reconnectMessage: (
      <Alert
        message="Your project has been upgraded. Click “Connect” below to complete the upgrade process and re-connect your project to slack."
        type="success"
        showIcon
        style={{ marginBottom: '16px' }}
      />
    )
  },
  teamwork: {
    postTo: 'your Teamwork kanban board',
    sync: { comments: true, status: true }
  },
  trello: {
    postTo: 'a Trello board and list',
    sync: { comments: true },
    map: { status: 'Trello lists' }
  },
  linear: { postTo: 'a Linear team', sync: { comments: true, status: true } },
  webhooks: { postTo: 'your Microsoft Teams channel', sync: { status: true } }
};

export const FeatureList = ({
  show,
  display,
  config: { postTo, sync, map, notifications }
}: {
  display: string;
  show: boolean;
  config: ConnectConfig;
}) => {
  if (!show) return null;
  const mapText = map?.status
    ? `Map ${map.status} to BugHerd statuses`
    : map && `Map statuses and users between BugHerd and ${display}`;
  return (
    <ul>
      {notifications &&
        [
          'Receive notifications',
          'Status Change notifications',
          'New comment notifications'
        ].map(item => <li key={item}>{item}</li>)}
      <li>Post tasks to {postTo}</li>
      {sync?.comments && <li>Sync comments with {display}</li>}
      {sync?.status && <li>Sync status updates to your connected tasks</li>}
      {mapText && <li>{mapText}</li>}
    </ul>
  );
};
